export const defaultPagination = {
  limit: 5,
  portion: 1,
};

export default {
  defaultPagination,
};
